import React, { useCallback, useEffect, useState } from "react";
import HeaderImage from "components/HeaderImage/HeaderImage";
import EventsImage from "assets/images/headerImage/EventsImage.png";
import SearchBar from "components/SearchBar/SearchBar";
import { Row, Col, Empty, List, Card, Typography, Checkbox } from "antd";
import axios from "axios";
import SingleEventBox from "kd/containers/Events/SingelEventBox/SingleEventBox";
import EventFilterComponent from "containers/Events/EventFilter/EventFilter";
import dayjs from "dayjs";
import { Event } from "interfaces/events";
import { useLoginContext, isCompanyUser } from "contexts/LoginContext/LoginContext";
import { getFilteredEvents, getEventStatusMessage } from "./helpers";
import KarriereKveldenBox from "./SpecialEventBoxes/KarriereKveldenBox";
import SIPBox from "./SpecialEventBoxes/SIPBox";

const KDEvents = () => {
  const [events, setEvents] = useState<Event[]>([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [sectorsChecked, setSectorChecked] = useState<number[]>([]);
  const [ownEvents, setOwnEvents] = useState<boolean>(false);

  const { currentUser } = useLoginContext();

  const toggleCheckedSectors = useCallback(
    (id: number) =>
      setSectorChecked(previousState => {
        if (previousState.includes(id)) return previousState.filter(x => x !== id);
        return [...previousState, id];
      }),
    []
  );

  const toggleOwnEvents = () => setOwnEvents(!ownEvents); // Companies only see own events

  const handleSearch = (newSearchTerm: React.SetStateAction<string>) => {
    setSearchTerm(newSearchTerm);
  };

  useEffect(() => {
    axios.get<Event[]>("/events/").then(response => {
      setEvents(response.data);
    });
  }, []);

  const AxiosEvents = getFilteredEvents(events, searchTerm, sectorsChecked).map(event => {
    if (event.is_visible === 0 || event.is_visible === 2) return null; // 0: Not visible, 2: Only visible in app
    if (ownEvents && event.company.id !== currentUser?.id) return null;

    const getTime = () => {
      if (!event.start) return "Ikke bestemt";
      return dayjs(event.start).format("HH:mm");
    };
    const getLocation = () => {
      if (event.location === null) return "Ikke bestemt";
      return `${event.location}`;
    };
    return (
      <Col key={event.id} style={{ marginBottom: "1em" }}>
        <SingleEventBox
          key={event.id}
          id={event.id}
          title={event.name}
          location={getLocation()}
          time={getTime()}
          date={event.start}
          company={event.company}
        />
      </Col>
    );
  });

  return (
    <>
      <HeaderImage imageLink={EventsImage} alt="EventsImage" header="Arrangementer" />
      <Row justify="center" style={{ paddingLeft: "5%", paddingRight: "5%", marginTop: "40px", marginBottom: "40px" }}>
        <Col xs={24} sm={24} md={19} lg={19}>
          <SearchBar value={searchTerm} handleSearch={handleSearch} placeholder="Søk..." />
        </Col>
      </Row>
      <Row style={{ paddingLeft: "5%", paddingRight: "5%" }}>
        <Col xs={24} sm={24} md={6} lg={6}>
          {isCompanyUser(currentUser) ? (
            <Card bodyStyle={{ padding: "2em" }} style={{ marginBottom: "1em" }}>
              <Col>
                <Checkbox checked={ownEvents} onChange={() => toggleOwnEvents()} value={ownEvents}>
                  <Typography>Vis kun mine arrangementer</Typography>
                </Checkbox>
              </Col>
            </Card>
          ) : null}
          <EventFilterComponent
            toggleCheckedSectors={toggleCheckedSectors}
            sectorsChecked={sectorsChecked}
            onFilterReset={() => {
              setSectorChecked([]);
              handleSearch("");
            }}
          />
        </Col>
        <Col xs={24} sm={24} md={1} lg={1} style={{ minHeight: "2em" }} />
        <Col xs={24} sm={24} md={17} lg={17}>
          <List
            itemLayout="vertical"
            pagination={{
              pageSize: 20,
              responsive: true,
              defaultCurrent: 1,
              defaultPageSize: 50,
              pageSizeOptions: ["20", "50"],
              hideOnSinglePage: true,
            }}
            locale={{
              emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={getEventStatusMessage(events)} />,
            }}
            dataSource={[<SIPBox key="sip" />, <KarriereKveldenBox key="karrierekvelden" />].concat(
              AxiosEvents.filter((event): event is JSX.Element => event !== null)
            )}
            renderItem={item => item}
          />
          <br />
        </Col>
      </Row>
    </>
  );
};

export default KDEvents;
